import onlCamImg from "../../../images/onl-cam.svg";
import offlCamImg from "../../../images/offl-cam.svg";
import unplacedCamImg from "../../../images/unplaced_cam.svg";


const Cameras = ({cameraObj, index, placedCamera}) => {

    return (
        <div className="camera-details-container" key={cameraObj.camera_id}
            style={{borderColor: placedCamera?.placed ? (cameraObj.camera_status ? '#2cc853' : '#f33456') : 'rgba(255, 255, 255, 0.08)',
                    color: !placedCamera?.placed && '#9aa3aa' ,
            }}
        >
            <div className="camera-container">
                <img 
                    src={
                    (cameraObj.camera_status === 1 ? (placedCamera?.placed ? onlCamImg : unplacedCamImg) : (placedCamera?.placed ? offlCamImg : unplacedCamImg))
                    } 
                    alt="cam-img"
                    className='cam-img'>    
                </img>
            </div>
            <div className="camera-details">
                <span className="camera-number">{cameraObj.camera_name}</span>
                <p><b>Server</b>: {cameraObj.server_name}</p>
            </div>
            <div className="camera-placed">
                {/* Status */}
                <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: cameraObj.camera_status === 1 ? '#39ff14' : 'red',
                    boxShadow: '0 0 0 3px rgba(39, 174, 96, 0.2)'}}
                >
                </div>
            </div>
        </div>
    );
}

export default Cameras;